export default {
	company:'北京秋俊天互联网科技有限公司',
	companyAbbr:'秋俊天',
	companyDesc:'一站式现代信息化建设解决方案供应商',
	companyBuildYear:'2016',
	companyUrl:'https://www.qiujuntian.com',
	companyEmail:'wonder&#64;qiujuntian.com',

	policeRegisteCode:'京公网安备11011102002077号',
	webRegisteCode:'京ICP备17036848号',
	
	logo:'/static/img/logo/qjt.svg',
	logoAnimate:'/static/img/logo/qjt_animate.svg',

	invoice:[
		'公司名称：北京秋俊天互联网科技有限公司',
		'税号：91110111MA00AXM44B',
		'公司地址：北京市房山区城关街道顾八路1区1号-T90',
		'开户行：中国建设银行股份有限公司北京良乡昊天支行',
		'联行号：105100007032',
		'账户：11050169820000000856',
		'电子邮箱：wonder&#64;qiujuntian.com'
	].join("\n"),
}
